import {isTouchDevice, setVhUnit, setScrollbarWidth, setViewportDimensions} from "./modules/utilities";
import FeatureDetail from "./modules/feature-detail";
import Embed from "./modules/embed";
import animateShowcase from "./modules/animate-showcase";
import animateContact from "./modules/animate-contact";
import animateInfo from "./modules/animate-info";
import animateVideo from "./modules/animate-video";
import {initAnimation} from "./modules/animation";
import animateIntro from "./modules/animate-intro";
import animateFeatures from "./modules/animate-features";
import {initNav} from "./modules/nav";
import {initVariants} from "./modules/variants";

function init() {

  // DEBUG
  const skipIntro = 0;
  // const logo = document.querySelector('.brand');
  // logo.addEventListener('click', e => {
  //   e.preventDefault();
  //   document.documentElement.classList.toggle('snap');
  // });

  // Touch device
  isTouchDevice();

  // Set viewport related variables
  // setVhUnit();
  // window.addEventListener('resize', setVhUnit);

  setViewportDimensions();
  window.addEventListener('resize', setViewportDimensions);

  // Set scrollbar width
  // setScrollbarWidth();

  // Nav
  initNav();

  // Language switch
  const langSwitch = document.querySelector('.lang-switch');
  document.addEventListener('click', e => {
    if (!e.target.closest('.lang-switch')) {
      langSwitch.open = false;
    }
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && langSwitch.open) {
      langSwitch.open = false;
    }
  });

  // GSAP
  initAnimation();

  // Section: Intro
  animateIntro(skipIntro);

  const variants = document.querySelector('.variant-list');
  initVariants(variants);

  // Section: Features
  animateFeatures();

  const toggles = document.querySelectorAll('[data-detail-toggle]');
  FeatureDetail(toggles);

  // Section: Video
  animateVideo();

  //const video = document.querySelector('.embed');
  //Embed(video);

  // Section: Info
  animateInfo();

  // Section: Showcase
  animateShowcase();

  // Section: Contact
  animateContact();

  togglePopup();

  //prevents intro from playing at wrong position due to scroll position memory
  if('scrollRestoration' in history) {
    window.scrollTo(-100,1);
    history.scrollRestoration = 'manual';
  }

  //ios specific fix
  document.querySelector('html').style.scrollBehavior = 'auto';
  document.querySelector('html').style.scrollSnapType = 'none';
  setTimeout(function() {
    document.querySelector('html').style.scrollBehavior = 'smooth';
    document.querySelector('html').style.scrollSnapType = 'y mandatory';
  }, 10000);

  window.onbeforeunload = function() {
    window.scrollTo(-100,1);
  }
}

function togglePopup() {
  var toggle = document.querySelector('.register__toggle');
  var register = document.querySelector('.register');
  var close = document.querySelector('.close');

  toggle.addEventListener('mouseenter', function(e) {
    if(!register.classList.contains('active')) {
      //e.preventDefault();
      register.classList.add('active');
    }
  });

  close.addEventListener('click', function() {
    register.classList.remove('active');
  });

  //opens popup after 2 mins as requested by design
  setTimeout(function() {
    register.classList.add('active');
  }, 120000);
}

window.addEventListener('DOMContentLoaded', init);
